<template>
  <section>
    <bl-text-av tag="h2" variation="heading-24" weigth="bold" align="center">
      {{ $options.testimonyList.title }}
    </bl-text-av>

    <div :style="leftDecoration">
      <div :style="rightDecoration">
        <div class="pt-12 mb-32 u-txt--center">
          <new-webp-image-container
            src="illustrations/img_medium_rating.png"
            alt="rating"
            :is-ssr="isSSR"
            styles="width: 264px; height: 164px"
          />
        </div>

        <div v-if="mutualFundTestimonies">
          <bl-slider-mv
            class="mb-24 pt-28"
            :items="mutualFundTestimonies.length"
            :slider-item-height="140"
            :slider-item-width="300"
            :is-show-indicator="false"
            :is-looping="false"
            background-slider="transparent"
            @itemChange="onItemChange"
          >
            <article v-for="(testimony, index) in mutualFundTestimonies" :key="index" :slot="`item${index + 1}`">
              <bl-card-mv style="position: relative; height: 140px;padding: 36px 12px 12px" is-outlined>
                <bl-avatar-av
                  size="xlarge"
                  style="position: absolute; top: 0px; left: 50%; transform: translate(-50%, -50%); background: #fff; border: 1px solid #EBEBEB"
                >
                  <img :src="testimony.image_url" alt="avatar" />
                </bl-avatar-av>
                <bl-text-av class="mb-12" variation="caption-12" align="center">
                  <q>
                    {{ testimony.content }}
                  </q>
                </bl-text-av>
                <bl-text-av variation="caption-12" weight="bold" align="center">
                  {{ testimony.name }}
                </bl-text-av>
              </bl-card-mv>
            </article>
          </bl-slider-mv>

          <bl-flex-container-mv class="pb-32 ph-16" justify-content="center">
            <bl-flex-item-av>
              <bl-slider-indicator-av :count="mutualFundTestimonies.length" :active="activeIndicator" />
            </bl-flex-item-av>
          </bl-flex-container-mv>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* istanbul ignore file */
import { assetURL } from 'shared/helpers/assetHelper';
import { TestimonyList as testimonyList } from 'shared/modules/seo/Homepage';
import BlTextAv from '@bukalapak/bazaar-mweb-2/dist/components/BlTextAv';
import BlSliderMv from '@bukalapak/bazaar-mweb-2/dist/components/BlSliderMv';
import BlCardMv from '@bukalapak/bazaar-mweb-2/dist/components/BlCardMv';
import BlSliderIndicatorAv from '@bukalapak/bazaar-mweb-2/dist/components/BlSliderIndicatorAv';
import NewWebpImageContainer from 'shared/components/NewWebpImageContainer';
import BlFlexContainerMv from '@bukalapak/bazaar-mweb-2/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-mweb-2/dist/components/BlFlexItemAv';
import BlAvatarAv from '@bukalapak/bazaar-mweb-2/dist/components/BlAvatarAv';

export default {
  name: 'TestimonyList',

  testimonyList,

  components: {
    BlTextAv,
    NewWebpImageContainer,
    BlSliderMv,
    BlCardMv,
    BlFlexContainerMv,
    BlFlexItemAv,
    BlSliderIndicatorAv,
    BlAvatarAv,
  },

  data() {
    return {
      activeIndicator: 1,
    };
  },

  computed: {
    mutualFundTestimonies() {
      return this.$store.state.server.mutualFundTestimonies;
    },

    isSSR() {
      return this.$root.isSSR;
    },

    leftDecoration() {
      return {
        'background-repeat': 'no-repeat',
        'background-position': 'top left',
        'background-image': `url(${assetURL('testimony_list_decoration_1.png', this.isSSR)})`,
        'background-size': '100%',
      };
    },

    rightDecoration() {
      return {
        'background-repeat': 'no-repeat',
        'background-position': 'top right',
        'background-image': `url(${assetURL('testimony_list_decoration_2.png', this.isSSR)})`,
        'background-size': '100% 100%',
      };
    },
  },

  created() {
    if (!this.$root.isSSR && !this.mutualFundTestimonies) {
      // Ignore error because
      this.$store.dispatch('server/retrieveMutualFundTestimonies');
    }
  },

  methods: {
    onItemChange(index) {
      this.activeIndicator = index;
    },
  },
};
</script>
